import { useQuery } from "@tanstack/react-query";

import type { ISegmentGeoRequestParams } from "app/services/segments/segmentsApiService";
import SegmentsApiService from "app/services/segments/segmentsApiService";

export const useSegmentsGeographyData = (apiParams: ISegmentGeoRequestParams) => {
    const segmentsApiService = new SegmentsApiService();
    return useQuery({
        queryKey: ["segmentsGeographyData", apiParams],
        queryFn: () => {
            const {
                from,
                to,
                timeGranularity = "Monthly",
                webSource = "Desktop",
                includeSubDomains = true,
                isWindow,
                sid,
                lastUpdated,
                country,
            } = apiParams;

            // Call the API and transform the data within the query function
            return segmentsApiService.getSegmentGeographyData({
                from,
                to,
                timeGranularity,
                webSource,
                includeSubDomains,
                sid,
                lastUpdated,
                isWindow,
                country,
            });
        },
    });
};
